/**
 * @architecture-header 1
 * @layer routes
 * @domain workspace-shell
 * @responsibility Render the global top bar: history controls and the centred command pill.
 * @state-owner navigation store
 * @allowed-imports React; workspace store; shared icons and hooks
 * @forbidden in-product role switching; API client; module internals
 * @public-api WorkspaceShell
 * @side-effects navigation history moves and overlay opening
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  RecentIcon,
  SearchIcon,
} from '../../shared/components/VispoIcon';
import { useTranslator } from '../../shared/model/use-workspace';
import { useWorkspaceUiStore } from '../../shared/model/workspace-store';

/**
 * The  role switch is intentionally absent: the role is chosen once on the
 * first-login selection screen and never toggled inside the product.
 */
export function TopBar({ onOpenSearch }: { onOpenSearch(): void }) {
  const t = useTranslator();
  const back = useWorkspaceUiStore((state) => state.back);
  const forward = useWorkspaceUiStore((state) => state.forward);
  const notify = useWorkspaceUiStore((state) => state.notify);
  const historyIndex = useWorkspaceUiStore((state) => state.historyIndex);
  const historyLength = useWorkspaceUiStore((state) => state.history.length);

  return (
    <header className="topbar">
      <div className="tbL">
        <button
          className="nvb"
          disabled={historyIndex <= 0}
          id="hbk"
          title={t('上一頁')}
          type="button"
          onClick={back}
        >
          <ChevronLeftIcon />
        </button>
        <button
          className="nvb"
          disabled={historyIndex >= historyLength - 1}
          id="hfw"
          title={t('下一頁')}
          type="button"
          onClick={forward}
        >
          <ChevronRightIcon />
        </button>
        <button className="nvb" title={t('最近')} type="button" onClick={() => notify('最近瀏覽')}>
          <RecentIcon />
        </button>
      </div>
      <button className="spill" type="button" onClick={onOpenSearch}>
        <SearchIcon />
        {t('輸入指令或搜尋')}
        <span className="kbd">⌘K</span>
      </button>
      <div className="tbR" />
    </header>
  );
}
